import type { ApiResponse } from '@/infrastructure/http/types';
import { DomainError } from '@/domain/error/DomainError';

/**
 * Garante que `res.success === true`. Caso contrário, joga DomainError padronizado.
 * O ofetchClient já normaliza erros HTTP em DomainError; este helper cobre o caso
 * (raro) de status 2xx com envelope `{success: false}`.
 */
export function assertApiSuccess<T>(res: ApiResponse<T>): void {
  if (!res.success) {
    throw new DomainError({
      code: 'UPSTREAM_SOFT_FAIL',
      message: res.message ?? 'O servidor respondeu sem sucesso.',
      status: 502,
    });
  }
}
